<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ backgroundColor }">
        <path
            d="M36.36 20L32.96 10.64C32.38 9.06 30.88 8 29.2 8H24V12H29.2L32.12 20H22.5L21.78 18H24V14H14V18H17.5L21.14 28H19.8C18.92 23.54 15.18 20.24 10.5 20.02C4.9 19.74 0 24.4 0 30C0 35.6 4.4 40 10 40C14.92 40 18.9 36.62 19.8 32H28.2C29.08 36.46 32.82 39.76 37.5 39.98C43.1 40.24 48 35.6 48 29.98C48 24.38 43.6 19.98 38 19.98H36.36V20ZM15.64 32C14.84 34.34 12.66 36 10 36C6.64 36 4 33.36 4 30C4 26.64 6.64 24 10 24C12.66 24 14.84 25.66 15.64 28H10V32H15.64ZM28.2 28H25.4L23.94 24H30C29.12 25.16 28.48 26.5 28.2 28ZM38 36C34.64 36 32 33.36 32 30C32 28.14 32.82 26.54 34.1 25.44L36.02 30.72L39.78 29.36L37.84 24.02C37.9 24.02 37.96 24 38.02 24C41.38 24 44.02 26.64 44.02 30C44.02 33.36 41.36 36 38 36Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
